export default __webpack_public_path__ + "static/media/cp_geo_mh.554fb812.svg";